import { signal, WritableSignal } from '@angular/core';
import { PaginationState } from '../models/common/pageable.model';

export const INITIAL_PAGINATION_STATE: PaginationState = {
  currentPage: 0,
  currentPageItems: 0,
  itemsPerPage: 10,
  totalItems: 0,
  loading: false,
};

/**
 * Cria um signal para o estado de paginação, garantindo reatividade e sincronização correta com o app-pagination.
 */
export function createPaginationState(
  initial?: Partial<PaginationState>
): WritableSignal<PaginationState> {
  return signal<PaginationState>({ ...INITIAL_PAGINATION_STATE, ...initial });
}

/** Estrutura padrão de resposta pageable (content + page) */
export interface PageableResultLike {
  content: unknown[];
  page: { page: number; total: number; size?: number };
}

/**
 * Atualiza o paginationState a partir de uma resposta pageable padrão.
 * Cria um novo objeto para disparar a reatividade do signal.
 * Para respostas aninhadas (ex: res.items), passe { content: res.items.content, page: res.items.page }.
 */
export function updatePaginationFromResult(
  state: WritableSignal<PaginationState>,
  result: PageableResultLike,
  pageSize: number
): void {
  const pageInfo = result.page;
  state.set({
    currentPage: pageInfo.page,
    totalItems: pageInfo.total ?? 0,
    currentPageItems: result.content.length,
    itemsPerPage: pageInfo.size ?? pageSize,
    loading: false,
  });
}

/**
 * Define o estado de loading da paginação.
 */
export function setPaginationLoading(
  state: WritableSignal<PaginationState>,
  loading: boolean
): void {
  state.update((p) => ({ ...p, loading }));
}

/**
 * Define o estado completo da paginação (para respostas com formato não padrão).
 */
export function setPaginationState(
  state: WritableSignal<PaginationState>,
  partial: Partial<PaginationState>
): void {
  state.update((p) => ({ ...p, ...partial }));
}
